import { Client } from '@stomp/stompjs';
import React from 'react';
import SockJS from 'sockjs-client';
import { Toast } from 'react-bootstrap';
import { getBNYWSBaseUrl } from '../../services/apiService';
import {
  getAuthToken,
  getUserGroupId,
  getCounterpartyId,
  getUserId,
} from '../../services/authService';
import { Props, State } from './webSocketModel';
import {
  bnyTopicGroupEmitter,
  bnyTopicTenantEmitter,
  bnyTopicUserEmitter,
} from './webSocketEmitter';
import { initializeGlobalSubscriber, unsubscribe } from './webSocketSubscriber';

export default class WebSocketNotification extends React.Component<Props, State> {
  bnyClient: any;

  constructor(props) {
    super(props);
    this.state = {
      isConnectionLost: false,
    };
  }

  componentDidMount() {
    this.connectBNYClient();

    const { setNotificationData, getAllOrders, getClosedOrders } = this.props;

    const action = { getAllOrders, getClosedOrders };
    initializeGlobalSubscriber(action, setNotificationData);
  }

  componentWillUnmount() {
    unsubscribe();
  }

  connectBNYClient = () => {
    this.bnyClient = new Client({
      connectHeaders: {
        Authorization: getAuthToken(),
      },
      debug: function (str) {},
    });

    this.bnyClient.onConnect = (cb) => {
      console.log(`BNY Websocket connected: ${new Date()}`);
      this.bnyNotifier(getUserGroupId());

      const tenantTopicOrderUrl = `/topic/tenant-${getCounterpartyId()}`;
      this.bnyClient.subscribe(tenantTopicOrderUrl, (notification) => {
        console.log('Topic tenant', notification);
        bnyTopicTenantEmitter.next(notification);
      });
    };

    this.bnyClient.onDisconnect = (cb) => {
      console.log(`BNY onDisconnect: ${new Date()}\n`, cb);
    };

    this.bnyClient.onStompError = (cb) => {
      console.log(`BNY onStompError: ${new Date()}\n`, cb);
    };

    this.bnyClient.onWebSocketError = (cb) => {
      console.log(`BNY onWebSocketError: ${new Date()}\n`, cb);
    };

    this.bnyClient.onWebSocketClose = (cb) => {
      console.log(`BNY onWebSocketClose: ${new Date()}\n`, cb);
    };

    this.bnyClient.webSocketFactory = () => {
      return new SockJS(`${getBNYWSBaseUrl()}?tId=${getCounterpartyId()}`);
    };

    this.bnyClient.activate();
  };

  bnyNotifier = (groupId) => {
    const topicGroupUrl = `/topic/group-${groupId}`;
    this.bnyClient.subscribe(topicGroupUrl, (notification) => {
      const body = JSON.parse(notification.body);
      if (
        [
          'TRADE_CREATED',
          'TRADE_STATUS_UPDATED',
          'TRADE_CANCELLED',
          'BASKET_STATUS_UPDATED',
        ].includes(body.type)
      ) {
        bnyTopicGroupEmitter.next(body);
      }
    });

    const userTopicAlpUrl = `/topic/user-${getUserId()}`;
    this.bnyClient.subscribe(userTopicAlpUrl, (notification) => {
      bnyTopicUserEmitter.next(notification);
    });
  };

  render() {
    const { isConnectionLost } = this.state;

    if (!isConnectionLost) return null;

    return (
      <Toast
        animation
        className={`notification-wrapper bg-warning`}
        show={isConnectionLost}
        style={{ position: 'fixed', top: 0, right: 0, minWidth: 270 }}
        onClose={() => this.setState({ isConnectionLost: false })}
      >
        <Toast.Header>
          <span className="d-block">The connection has timed out.</span>
        </Toast.Header>
        <Toast.Body>
          <div className="d-flex align-items-center align-self-center">
            <div className=""> Please refresh the page.</div>
            <button
              className="btn btn-xs btn-light mx-2 px-2"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
          </div>
        </Toast.Body>
      </Toast>
    );
  }
}
